
import React, {ReactNode} from "react";
import Box from '@mui/material/Box';

type VerticalSpaceContainerProps = {
    children: ReactNode;
    [key: string]: any; // For any additional props
}

export const VerticalSpaceContainer : React.FC<VerticalSpaceContainerProps> = ({children,...props}) => {
    return (
        <Box {...props} /*sx={{'& > * + *' : {mt : 4}, ...props?.sx}}*/ >
            {children}
        </Box>
    )
}

export default VerticalSpaceContainer;
